import React from "react";
import { Editor } from "@tinymce/tinymce-react";

const key = "2snaiiqoggpk5xr1v5k7dng23muq3y6vhaqf0pt06kyrxl33";

type Props = {
  value: string;
  onChange?: (contents: string, Editor: any) => void;
};

export default function WkEditor(props: Props) {
  const { onChange, value } = props;

  console.log("defaluValue:", props);
  const handleEditorChange = (content: string, editor: any) => {
    console.log("Content was updated:", content);
    if (onChange) {
      onChange(content, editor);
    }
  };

  return (
    <Editor
      value={value}
      apiKey={key}
      textareaName="htmltext"
      initialValue={value}
      init={{
        height: 500,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount",
        ],
        a11y_advanced_options: true,
        language: "ja",
        extended_valid_elements: "script[src|async|defer|type|charset]",
        toolbar:
          // eslint-disable-next-line no-multi-str
          "undo redo | formatselect | bold italic backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat |  image | help",
      }}
      onEditorChange={handleEditorChange}
    />
  );
}
